module.exports = __webpack_public_path__ + "static/img/style1.4654da15.png";